import { library } from '@fortawesome/fontawesome-svg-core';
import { faLaptopCode, 
  faPalette, 
  faMobileAlt, 
  faTools, 
  faMagnifyingGlass, 
  faRocket, 
  faStar, 
  faCircleCheck, 
  faMinus, 
  faCircleInfo, 
  faAngleDown, 
  faChevronRight, 
  faChevronLeft,
  faLock,
  faMobileScreen,
  faMagnifyingGlassChart
  } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';

// Add any icons you want to use globally here
library.add(
  faLaptopCode,
  faPalette,
  faMobileAlt,
  faTools,
  faGithub,
  faLinkedin,
  faTwitter,
  faMagnifyingGlass, 
  faRocket,
  faStar, 
  faCircleCheck, 
  faMinus, 
  faCircleInfo, 
  faAngleDown, 
  faChevronRight, 
  faChevronLeft,
  faLock,
  faMobileScreen,
  faMagnifyingGlassChart
);